import { faFaceSadSweat, faGhost, IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import React from "react";
import "../../PlanningApplication.css";

interface NoCommentsMessage {
    message: string;
    variant: NoCommentMessageVariant;
}

const noCommentsIconColor: NoCommentsIconColor = {
    disabled: PublicPortalTheme.palette.error.main,
    empty: PublicPortalTheme.palette.primary.main,
};
const noCommentsIcon: NoCommentsIcon = {
    disabled: faFaceSadSweat,
    empty: faGhost,
};

const NoCommentsMessage: React.FC<NoCommentsMessage> = ({ message, variant }) => {
    return (
        <Box className="comments__disabled-communicate--wrapper">
            <FontAwesomeIcon color={noCommentsIconColor[variant]} className="comments__comments-not-allowed-icon" icon={noCommentsIcon[variant]} />
            <Typography variant="h5">{message}</Typography>
        </Box>
    );
};

type NoCommentMessageVariant = "disabled" | "empty";
type NoCommentsIconColor = {
    [keyof in NoCommentMessageVariant]: string;
};
type NoCommentsIcon = {
    [keyof in NoCommentMessageVariant]: IconDefinition;
};

export default NoCommentsMessage;
